import React, { useState } from "react";
import "./auth.css";
import { Btn, FormCheckbox, FormInput, SuccessComp, validateRequiredFields } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import { AxiosPost } from "../../api/api";

const DevSignupComp = () => {
  const url = "auth/register/developer/";
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const [data, setData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    // confirmPassword: "",
    state: "",
    city: "",
    developerName: "",
    // agentId: "",
    check: false,
  });

  const [dataErr, setDataErr] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    // confirmPassword: "",
    state: "",
    city: "",
    developerName: "",
    // agentId: "",
  });
  const requiredFields = {
    name: true,
    email: true,
    phoneNumber: true,
    password: true,
    state: true,
    city: true,
    developerName: true,
    check: true,
  };

  const isValid = validateRequiredFields(data, requiredFields);
  

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);

    if (e.target.id === "custom-checkbox") {
      setData({ ...data, check: e.target.checked });
      // console.log(e.target.checked);
    }
    // console.log(newData);
  };

  const dataObj = {
    name: data.name,
    email: data.email,
    phoneNumber: data.phoneNumber,
    password: data.password,
    state: data.state,
    city: data.city,
    developerName: data.developerName,
  };

  const regAgent = () => {
    setIsLoading(true);
    AxiosPost(url, dataObj)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res.message);
        setData({
          ...data,
          check: false,
        });
        setTimeout(() => {
          navigate("/auth/signin");
          setSuccessMsg("");
        }, 2000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };

  return (
    <div className="agent-signup">
      <SuccessComp message={successMsg} />
      <h2>
        <span>Developer </span>Registration
      </h2>
      <h3>Expand your client base and list properties effortlessly</h3>
      <div className="agent-form">
        <FormInput
          type="text"
          label={"Name"}
          id={"name"}
          value={data.name}
          changeInput={dataChange}
          err={dataErr.name}
        />
        <FormInput
          type="email"
          label={"Email"}
          id={"email"}
          value={data.email}
          changeInput={dataChange}
          err={dataErr.email}
        />
        <FormInput
          type="phone"
          label={"Phone Number"}
          id={"phoneNumber"}
          value={data.phoneNumber}
          changeInput={dataChange}
          err={dataErr.phoneNumber}
        />
        <FormInput
          label={"Password"}
          isPassword
          id={"password"}
          value={data.password}
          changeInput={dataChange}
          err={dataErr.password}
        />
        {/* <FormInput label={"Confirm Password"} placeholder="******" isPassword id={"confirmPassword"} value={data.confirmPassword} changeInput={dataChange} /> */}
        <FormInput
          type="text"
          label={"State"}
          id={"state"}
          value={data.state}
          changeInput={dataChange}
          err={dataErr.state}
        />
        <FormInput
          type="text"
          label={"City"}
          id={"city"}
          value={data.city}
          changeInput={dataChange}
          err={dataErr.city}
        />
        <FormInput
          type="text"
          label={"Developer Name"}
          id={"developerName"}
          value={data.developerName}
          changeInput={dataChange}
          err={dataErr.developerName}
        />
        {/* <FormInput type="text" label={"Agent ID"} id={"agencyId"} value={data.agentId} changeInput={dataChange}  /> */}
      </div>
      <div className="form-terms">
        <FormCheckbox changeInput={dataChange} />
        <p>
          By clicking the box you agree to <span>PrimeProperty</span> Terms &
          Conditions
        </p>
      </div>
      <div className="sign-btn_cont agent-btn">
        <Btn
          btnClass={"home-btn sign-btn"}
          btnText={"Sign up"}
          btnClick={regAgent}
          disabled={!isValid}
          loading={isLoading}
        />
        <p>
          Already have an account?{" "}
          <Link to={"/auth/signin"} style={{ textDecoration: "none" }}>
            <span>Login</span>
          </Link>
        </p>
      </div>
    </div>
  );
};

export default DevSignupComp;
